<template>
  <div
    :id="`${source}_attachment_button`"
    v-if="visible"
    class="w-fit relative"
  >
    <input
      type="file"
      ref="fileInput"
      @change="handleChange"
      :multiple="multiple"
      class="hidden"
    />

    <template v-if="variant === variants.VARIANT1">
      <a-button class="secondary_medium w-fit" @click="triggerFileInput">
        <ThemeImage :icon="computedIcon" alt="upload_icon" class="size-4" />
        <span class="font-semibold">{{ label }}</span>
      </a-button>
    </template>

    <template v-if="variant === variants.VARIANT2">
      <div
        id="attachment_button"
        @click="triggerFileInput"
        class="flex gap-1 items-center justify-center cursor-pointer"
      >
        <ThemeImage
          :class="[`w-[${iconSize}px] h-[${iconSize}px]`]"
          :icon="computedIcon"
          alt="attachment_icon"
        />

        <span
          v-if="label"
          class="font-normal text_color text-sm leading-[17px]"
        >
          {{ label }}
        </span>
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { variants } from "@/src/constants/customComponentConstants.js";
import {
  attachmentTypeConfig,
  attachmentTypes,
} from "@/src/constants/attachmentConstants.js";

const props = defineProps({
  source: { type: String, required: true },
  visible: { type: Boolean, default: true },
  multiple: { type: Boolean, default: true },
  label: { type: String, default: "Attach files" },
  iconSize: { type: [Number, String], default: 20 },
  customIcon: { type: String, default: null },
  variant: {
    type: String,
    default: variants.VARIANT2,
    validator: (value) =>
      [variants.VARIANT1, variants.VARIANT2].includes(value),
  },
  type: {
    type: String,
    default: attachmentTypes.GRAY,
    validator: (value) => Object.keys(attachmentTypeConfig).includes(value),
  },
});

const emit = defineEmits(["file-selected"]);

const fileInput = ref(null);

const computedIcon = computed(() => {
  return props.customIcon || attachmentTypeConfig[props.type].icon;
});

const triggerFileInput = () => {
  try {
    if (fileInput?.value) {
      fileInput.value?.click();
    }
  } catch (error) {
    console.error("An error occurred while triggering file input: ", error);
  }
};

const handleChange = (event) => {
  try {
    emit("file-selected", event?.target?.files);
    event.target.value = "";
  } catch (error) {
    console.error("An error occurred while handling change: ", error);
  }
};

defineExpose({
  triggerFileInput,
});
</script>
